module.exports = __webpack_public_path__ + "img/Friendly Unlocked.a34b8ea.png";